import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-md-10" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "row mb-2" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "row mb-2" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "row mb-2" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "row mb-2" }
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = {
  key: 0,
  class: "row"
}
const _hoisted_14 = { class: "col-md-10 fw-bold text-danger" }
const _hoisted_15 = {
  key: 1,
  class: "row"
}
const _hoisted_16 = { class: "col-md-9 fw-bold" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = ["disabled"]

import { onMounted, reactive, watch } from "vue";

//servicos
import * as service from "@/services/BoletosService";
import { f2dec} from "@/utils/funcoes";

//componentes
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import DropdownParamBoleto from "@/components/Dropdowns/DropdownParamBoleto.vue";
import Loading from "@/components/Loading/index.vue";

interface IProps {
    exibir: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GerarBoletos',
  props: {
    exibir: { type: Boolean }
  },
  emits: ["gerou","erro", "fechou"],
  setup(__props: any, { emit: __emit }) {


//vue
var props = __props;

var emit = __emit;

var controle = reactive({ 
    
    janGerarBoletos: false,
    param: {
        paramBoletoId: 1,
        
    } as service.GerarBoletoFiltros,


    loading: false,
    status: "",
    erro: ""
});


watch(() => props.exibir, async (novoValor) => {

    controle.janGerarBoletos = novoValor;

    if (controle.janGerarBoletos == true)
    {
        setTimeout(() => {
            var jan = document.getElementById("janGerarBoletos");
            var el = jan?.querySelector("#inputFocus") as HTMLInputElement;
            if (el != undefined)
                el.focus();
        }, 700);
    }

})

async function gerar(){

    controle.erro = "";
    controle.status = "";
    controle.loading = true;

    controle.status = `Gerando boletos ...`;

    await service.gerarBoletos(controle.param)
    .then(r=> {
        controle.status =  `OK`;
        emit("gerou");

        setTimeout(() => {
            controle.loading = false;
            fechar();
        }, 4000);

        controle.janGerarBoletos = false;
    })  
    .catch((erro) => {
        controle.erro = erro;
        controle.status = "Erro: " + erro ;
        controle.loading = false;
        emit("erro", erro);
    });
}

function fechar() {
    controle.janGerarBoletos = false;
    emit("fechou");
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Loading, {
      isLoading: _unref(controle).loading,
      mensagem: _unref(controle).status
    }, null, 8, ["isLoading", "mensagem"]),
    _createVNode(MsgBox, {
      id: 'janGerarBoletos',
      titulo: 'Gerar Boletos',
      exibir: _unref(controle).janGerarBoletos,
      onOnFechou: _cache[8] || (_cache[8] = ($event: any) => (_unref(controle).janGerarBoletos = false))
    }, {
      default: _withCtx(() => [
        _createVNode(TrataTecla, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-md-2" }, " Convênio ", -1)),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(DropdownParamBoleto, {
                  modelValue: _unref(controle).param.paramBoletoId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).param.paramBoletoId) = $event)),
                  id: "inputFocus  "
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-md-2" }, [
                _createElementVNode("label", null, "Usuário")
              ], -1)),
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(controle).param.nomeUsuario) = $event)),
                  id: "nomeUsuario",
                  ref: "nomeUsuario"
                }, null, 512), [
                  [_vModelText, _unref(controle).param.nomeUsuario]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-md-2" }, [
                _createElementVNode("label", null, "Senha")
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).param.senha) = $event)),
                  ref: "senha"
                }, null, 512), [
                  [_vModelText, _unref(controle).param.senha]
                ])
              ])
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "row mb-2" }, [
              _createElementVNode("div", { class: "col-md-12 fw-bold" }, " Informe o período das mensalidades que deseja gerar boletos ")
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col-md-2" }, [
                _createElementVNode("label", null, "Data Inicial")
              ], -1)),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).param.dataInicial) = $event)),
                  id: "dataInicial",
                  ref: "dataInicial"
                }, null, 512), [
                  [_vModelText, _unref(controle).param.dataInicial]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-md-2" }, [
                _createElementVNode("label", null, "Data Final")
              ], -1)),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).param.dataFinal) = $event)),
                  id: "dataFinal",
                  ref: "dataFinal"
                }, null, 512), [
                  [_vModelText, _unref(controle).param.dataFinal]
                ])
              ])
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "row mb-2" }, [
              _createElementVNode("div", { class: "col-md-12 fw-bold" }, " Informe a data de vencimento que será atribuída aos boletos gerados ")
            ], -1)),
            _createElementVNode("div", _hoisted_11, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-md-2" }, [
                _createElementVNode("label", null, "Data Vencimento")
              ], -1)),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(controle).param.dataVencimento) = $event)),
                  id: "dataVencimento",
                  ref: "dataVencimento"
                }, null, 512), [
                  [_vModelText, _unref(controle).param.dataVencimento]
                ])
              ])
            ]),
            (_unref(controle).erro != '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col-md-2" }, null, -1)),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(controle).erro), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(controle).status != '' && _unref(controle).erro == '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-md-3" }, null, -1)),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fa fa-cog fa-spin" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(controle).status), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "row" }, [
              _createElementVNode("div", { class: "col-md-12" }, [
                _createElementVNode("hr")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-sm",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (gerar())),
                  disabled: _unref(controle).loading
                }, "Gerar", 8, _hoisted_19)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("a", {
                  class: "btn btn-secondary btn-sm float-end",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (fechar())),
                  disabled: _unref(controle).loading
                }, "Fechar", 8, _hoisted_21)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})